import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      icon: '📂',
      title: 'Import',
      description: 'Drop your .csv, .txt, or .kml field points into AutoCAD',
      animation: 'import'
    },
    {
      icon: '⚙️',
      title: 'Process',
      description: 'Select your target task: Contour, Mesh Volume, or Convert',
      animation: 'process'
    },
    {
      icon: '📤',
      title: 'Export',
      description: 'Get clean, layered CAD drawings or KML files instantly',
      animation: 'export'
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="section-header">
        <h2 className="section-title">How CivilCADPro Works</h2>
        <p className="section-subtitle">3 simple steps to transform your survey data</p>
      </div>
      
      <div className="steps-container">
        {steps.map((step, index) => (
          <div key={index} className="step-card">
            <div className="step-icon">
              {step.icon}
            </div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.description}</p>
            {index < steps.length - 1 && (
              <div className="step-arrow">→</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;